import { Container, Sprite, Text, TextStyle, Texture } from "pixi.js";
import { GameFont } from "../../../../common/GameFont";

export class WheelRewardContainer extends Container {
    public constructor(icon: Texture, rewardValue: number) {
        super();
        const rewardValueText = new Text(rewardValue.toString(), new RewardValueTextStyle());
        rewardValueText.anchor.set(0.5, 0.5);
        rewardValueText.position.y = rewardValueText.height * 0.5;
        this.addChild(rewardValueText);
        const rewardIcon = new Sprite(icon);
        rewardIcon.anchor.set(0.5, 0.5);
        rewardIcon.position.y = rewardValueText.x - rewardIcon.height * 0.5;
        this.addChild(rewardIcon);
    }
}

class RewardValueTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fill: "#ffffff",
            align: "center",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 54,
            stroke: "#790091",
            strokeThickness: 8
        }));
    }
}
